var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"draggable",class:['absolute cursor-pointer', _vm.borderClass, 'rounded-xl', 'z-40'],style:({ left: _vm.x + 'px', top: _vm.y + 'px' }),on:{"mousedown":_vm.startDrag}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }